export const initialState = {
    user: null,
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'USER_LOADED':
            console.log(state, action)
            localStorage.setItem('sessionId', action.payload?.sessionId ?? '');
            return {
                ...state,
                user: action.payload,
            };
        default:
            return state;
    }
};
